import React, { useEffect } from 'react';

const TermsOfService = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="terms-page py-5 bg-light">
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-5 rounded-4">
                    <h1 className="fw-bold mb-4 text-primary">Terms of Service</h1>
                    <p className="text-muted mb-5 italic">Last updated: December 22, 2025</p>

                    <section className="mb-5">
                        <h4 className="fw-bold">1. Acceptance of Terms</h4>
                        <p>
                            By accessing or using the Secure360 platform, you agree to be bound by these Terms of Service.
                            If you disagree with any part of the terms, you may not access the service.
                        </p>
                    </section>

                    <section className="mb-5">
                        <h4 className="fw-bold">2. Use of Service</h4>
                        <p>
                            You agree to use Secure360 only for lawful purposes. You must not use the platform to perform unauthorized
                            scanning of assets you do not own or have explicit permission to audit. Secure360 reserves the right to
                            terminate accounts suspected of malicious activity.
                        </p>
                    </section>

                    <section className="mb-5">
                        <h4 className="fw-bold">3. Accounts</h4>
                        <p>
                            When you create an account with us, you must provide accurate and complete information.
                            You are responsible for safeguarding the password that you use to access the service.
                        </p>
                    </section>

                    <section className="mb-5">
                        <h4 className="fw-bold">4. Disclaimer </h4>
                        <div className="alert alert-warning border-0 rounded-3 small">
                            Secure360 provides information "as is" and makes no warranties regarding the accuracy or
                            completeness of security scans. Our tools are designed for assessment and do not guarantee
                            immunity from cyber attacks.
                        </div>
                    </section>

                    <section className="mb-5">
                        <h4 className="fw-bold">5. Limitation of Liability</h4>
                        <p>
                            In no event shall Secure360, nor its directors, employees, or partners, be liable for any indirect,
                            incidental, or consequential damages resulting from your use of the service.
                        </p>
                    </section>

                    <section className="mb-5">
                        <h4 className="fw-bold">6. Changes</h4>
                        <p>
                            We reserve the right, at our sole discretion, to modify or replace these Terms at any time.
                            We will provide notice for any material changes via email or system notifications.
                        </p>
                    </section>

                    <section className="mb-5 border-top pt-4">
                        <h4 className="fw-bold text-primary-emphasis">Governing Law</h4>
                        <p className="mb-0">These Terms shall be governed and construed in accordance with the laws of our operating jurisdiction, without regard to its conflict of law provisions.</p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
